import { getSavedData } from "./setLocalStorage";
import { buildPriceData } from "./buildPriceDataName";

export const modelStepsData = (seriesUrl, modelUri, locked = [], activeStep) => {
    let res = JSON.parse(getSavedData(buildPriceData)) || {};

    const stepsData = {
        active: activeStep,
        steps: [
            { step: '01', title: 'Model', disabled: locked.toString().indexOf('1') != -1 ? true : false, url: locked.toString().indexOf('1') != -1 ? '#' : `${seriesUrl}?variant/` },
            { step: '02', title: 'Floor Plan', disabled: locked.toString().indexOf('2') != -1 ? true : false, url: locked.toString().indexOf('2') != -1 ? '#' : `${seriesUrl}?floorplan/` },
            { step: '03', title: 'Decor', disabled: locked.toString().indexOf('3') != -1 ? true : false, url: locked.toString().indexOf('3') != -1 ? '#' : `${seriesUrl}/floorplan/${modelUri}?decor/` },
            { step: '04', title: 'Options', disabled: locked.toString().indexOf('4') != -1 ? true : false, url: locked.toString().indexOf('4') != -1 ? '#' : `${seriesUrl}/floorplan/${modelUri}?options/` },
            { step: '05', title: 'Summary', disabled: locked.toString().indexOf('5') != -1 ? true : false, url: locked.toString().indexOf('5') != -1 ? '#' : `${seriesUrl}/floorplan/${modelUri}/summary/` }
        ]
    }
    return (
        stepsData
    )
}

